export const toggleNode = (
  openMap: Record<string, boolean> | null,
  nodeId: string,
) => {
  if (openMap === null) {
    throw new Error("Open map is not initialized. Cannot toggle node.");
  }
  if (!nodeId) {
    throw new Error("Node ID is not provided. Cannot toggle node.");
  }
  const newOpenMap: Record<string, boolean> | null = openMap
    ? { ...openMap }
    : null;
  if (newOpenMap && nodeId in newOpenMap) {
    newOpenMap[nodeId] = !newOpenMap[nodeId];
    return newOpenMap;
  }
  if (newOpenMap !== null) {
    newOpenMap[nodeId] = false;
  }

  return newOpenMap;
};
